import type { CSSProperties, ReactNode } from "react";
import styles from "./Button.module.css";

interface ButtonProps {
  text: string;
  className?: string;
  onClick?: () => void;
  disabled?: boolean;
  icon?: string | ReactNode;
  size?: number;
  invertIconOnHover?: boolean;
  matchIconColorToText?: boolean;
}

export default function WhiteButton({
  text,
  className,
  onClick,
  disabled,
  icon,
  size = 16,
  invertIconOnHover = true,
  matchIconColorToText = false,
}: ButtonProps) {
  return (
    <button
      className={`${styles.whiteButton} ${className || ""}`}
      onClick={onClick}
      disabled={disabled}
    >
      {typeof icon === "string" &&
        (matchIconColorToText ? (
          <span
            className={styles.matchIconColorToText}
            style={{
              "--icon-url": `url(${icon})`,
              "--icon-size": `${size}px`,
            } as CSSProperties}
          />
        ) : (
          <img
            src={icon}
            alt="icon"
            className={`${styles.icon} ${
              invertIconOnHover ? styles.invertOnHover : ""
            }`}
            style={{ width: size, height: size }}
          />
        ))}
      {typeof icon !== "string" && icon && (
        <span className={styles.reactIcon} style={{ fontSize: size }}>
          {icon}
        </span>
      )}
      {text}
    </button>
  );
}
